import { SkeletonProps } from 'antd';
import React from 'react';

import { RenderHero } from '../../RenderHero';
import { StyledSkeleton } from './PageLoader.styles';

export const PageLoader: React.FC<SkeletonProps> = ({ paragraph, active, ...rest }) => {
  return (
    <>
      <RenderHero />
      <StyledSkeleton active paragraph={{ rows: 10 }} {...rest} />
    </>
  );
};
